/**
 * Deep-merge locale message trees (nested objects from vue-i18n / API).
 * Shallow spread would replace e.g. entire `auth` or `nav` when the API returns
 * only the keys present in MongoDB, wiping bundled siblings.
 */
export function mergeLocaleMessagesDeep(base, override) {
  if (override == null || typeof override !== 'object' || Array.isArray(override)) {
    return base;
  }
  if (base == null || typeof base !== 'object' || Array.isArray(base)) {
    return { ...override };
  }
  const out = { ...base };
  for (const key of Object.keys(override)) {
    const b = base[key];
    const o = override[key];
    if (
      o !== null &&
      typeof o === 'object' &&
      !Array.isArray(o) &&
      b !== null &&
      typeof b === 'object' &&
      !Array.isArray(b)
    ) {
      out[key] = mergeLocaleMessagesDeep(b, o);
    } else {
      out[key] = o;
    }
  }
  return out;
}
